export const FLOW_NAME = "market-mix-modelling";
export type FLOW_TYPE = "market-mix-modelling";

export const INPUT_DATA = "data";
export const RECIPE_NAME = "market-mix-modellingattribution";

export const TIMESTAMP_VAR_KEY = "time";
export const TARGET_VAR_KEY = "y-column";
export const GROUPING_VARS_KEY = "grouping-variables";

export const RESOLUTION_KEY = "resolution";
export const DECAY_RATE_KEY = "decay-rate";
export const S_CURVE_PARAMS_KEY = "mappers";
export const GET_SEASONALITY_KEY = "get_seasonality";

export const SPEND_PARAMS_KEY = "spend-parameters";
export const ACTIVITY_PARAMS_KEY = "salesforce-activity-parameters";

export const BETA_DIRECTIONS_KEY = "beta-directions";
export const PARAMS_WITHOUT_DIMINISHING_RETURNS_KEY =
  "params-without-diminishing-returns";

export const NON_SPEND_PARAMS_KEY = "non-spend-variables";
export const PARAMS_WITH_NEG_BETA_KEY = "negative-beta-variables";

export const RUN_ID = "RUN_ID";
export const INIT_RUN = "INIT_RUN";
export const CREATED_BY = "CREATED_BY";
export const TIME_STAMP = "TIME_STAMP";

export const BAYESIAN_REGRESSION = "bayesian_regression";
export const RIDGE_REGRESSION = "ridge_regression";

export const ALGORITHMS = [BAYESIAN_REGRESSION];
